/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Dimensions } from 'react-native';
import { Orientation } from '@airasia-phoenix/react-native/utils/utils';
import { CabinClassType } from './types';

const Constants = {
  get DIVIDER_WIDTH() {
    const screenWidth = Dimensions.get('screen').width;
    const spaceAround = 24 * 2;
    const dividerWidth = screenWidth - spaceAround;
    return dividerWidth;
  },
  get CHIP_WIDTH() {
    const screenWidth = Dimensions.get('screen').width;

    // Max width for web modal (from design / screenshot)
    const MAX_CONTAINER_WIDTH = 560;

    const effectiveWidth =
      screenWidth > MAX_CONTAINER_WIDTH ? MAX_CONTAINER_WIDTH : screenWidth;

    const spaceInBetween = 24 * 2 + 16;
    const spaceForChips = effectiveWidth - spaceInBetween;

    return spaceForChips / 2;
  },
  CHIP_HEIGHT: 55,
  get CLASS_CHIP_GROUP_ORIENTATION() {
    const horizontalSpacing = 12;
    const verticalSpacing = 16;
    return new Orientation.Wrap(0, 0, verticalSpacing, horizontalSpacing);
  },
  MAX_TOTAL_PASSENGER_COUNT: 9,
  DEFAULT_ADULT_COUNT: 1,
  DEFAULT_CHILD_COUNT: 0,
  DEFAULT_INFANT_COUNT: 0,
  DEFAULT_INITIAL_PASSENGER_COUNT: 1,
  DEFAULT_PASSENGER_CLASS: CabinClassType.ECONOMY,
  PASSENGER_CLASS_BOTTOM_SHEET_HEIGHT: 515,
  PASSENGER_CLASS_HEIGHT: 390,
};
export default Constants;
